import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
    getKeyTypes,
    getKeyType,
    createKeyType,
    editKeyType,
    deleteKeyType,
} from "api/keyTypeApi"

export const KEY_TYPE_QUERY_KEY = "keyTypes"

export const useKeyTypes = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [KEY_TYPE_QUERY_KEY, params],
    queryFn: () => getKeyTypes(params),
    keepPreviousData: true,
    enabled
  })
}

export const useKeyType = (id) => {
  return useQuery({
    queryKey: [KEY_TYPE_QUERY_KEY, id],
    queryFn: () => getKeyType(id),
    enabled: !!id,
  })
}

export const useCreateKeyType = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createKeyType,
    onSuccess: () => {
      queryClient.invalidateQueries([KEY_TYPE_QUERY_KEY])
    },
  })
}

export const useEditKeyType = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: editKeyType,
    onSuccess: () => {
      queryClient.invalidateQueries([KEY_TYPE_QUERY_KEY])
    },
  })
}

export const useDeleteKeyType = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteKeyType,
    onSuccess: () => {
      queryClient.invalidateQueries([KEY_TYPE_QUERY_KEY])
    },
  })
}
